import { useQueryClient } from "@tanstack/react-query";
import { Select, SelectProps } from "antd";
import {
  useInventoryServiceGetProductParentCategory,
  useInventoryServiceGetProductParentCategoryKey,
} from "api/queries";
import { IGetProductCategoryOptionItemsResponse } from "api/requests";
import queryString from "qs";
import { useEffect, useState } from "react";

interface IProductCategorySelectProps {
  isForm?: boolean;
  onChange?: (value: any) => void;
  value?: string | number | null;
  items?: IGetProductCategoryOptionItemsResponse[];
  selectProps?: Partial<SelectProps>;
}

const ParentCategorySelectWithForm: React.FC<IProductCategorySelectProps> = ({
  isForm,
  onChange,
  value,
  items,
  selectProps,
}) => {
  const [filters, setFilters] = useState("");

  const { data, isLoading, isRefetching, refetch } =
    useInventoryServiceGetProductParentCategory(
      {
        filters,
        pagination: queryString.stringify({ limit: 1000, offset: 0 }),
        sort: "",
      },
      [useInventoryServiceGetProductParentCategoryKey]
    ); 
  
  const handleFilter = (value: string) => {
    setFilters(
      value
        ? queryString.stringify({
            productCategoryName: {
              $ilike: `${value}%`,
            },
          })
        : ""
    );
  };

  useEffect(() => {
    refetch();
  }, [filters]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        //@ts-ignore
        onChange(v);
      }}
      showSearch
      allowClear
      loading={isLoading || isRefetching}
      placeholder="Select a category"
      notFoundContent={false}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      options={
        data?.items?.map((_v) => {
          return {
            label: _v.productCategoryName,
            value: _v.idProductCategory,
            key:
              _v.idProductCategory + "product-category-select-product-category",
          };
        }) ?? []
      }
      onSearch={handleFilter}
      {...selectProps}
    />
  );
};

const ParentCategorySelectNoForm: React.FC<IProductCategorySelectProps> = ({
  isForm,
  onChange,
  value,
  items,
  selectProps,
}) => {
  const [filters, setFilters] = useState("");

  const { data, isLoading, isRefetching, refetch } =
    useInventoryServiceGetProductParentCategory(
      {
        filters,
        pagination: queryString.stringify({ limit: 1000, offset: 0 }),
        sort: "",
      },
      [useInventoryServiceGetProductParentCategoryKey]
    );

  const handleFilter = (value: string) => {
    setFilters(
      value
        ? queryString.stringify({
            productCategoryName: {
              $ilike: `${value}%`,
            },
          })
        : ""
    );
  };

  useEffect(() => {
    refetch();
  }, [filters]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        //@ts-ignore
        onChange(v);
      }}
      showSearch
      allowClear
      loading={isLoading || isRefetching}
      placeholder="Select a category"
      notFoundContent={false}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      options={
        data?.items?.map((_v) => {
          return {
            label: _v.productCategoryName,
            value: _v.idProductCategory,
            key:
              _v.idProductCategory + "product-category-select-product-category",
          };
        }) ?? []
      }
      onSearch={handleFilter}
      {...selectProps}
    />
  );
};

export default function ParentCategorySelect(props: IProductCategorySelectProps) {
  if (props.isForm) {
    return <ParentCategorySelectWithForm {...props} />;
  }
  return <ParentCategorySelectNoForm {...props} />;
}